import CreateGroupOfUsers from './component'

export default CreateGroupOfUsers
